import classcat from "classcat";
import React from "react";

import MaskedItem from "./MaskedItem";
import { PASSCODE_ITEMS } from "./Passcode.constants";
import css from "./Passcode.module.css";
import PasscodeItem from "./PasscodeItem";
import useManagePasscode from "./hooks/useManagePasscode";

type Props = {
  maskedPasscode: string[];
  onPasscodeViewClose: () => void;
};

const Passcode = ({ onPasscodeViewClose, maskedPasscode }: Props) => {
  const { passcode, handleClick, isShaking } = useManagePasscode({
    onPasscodeViewClose,
    maskedPasscode,
  });

  return (
    <div className={css.container}>
      <div
        className={classcat([
          css.maskedItemsContainer,
          { [css.shake]: isShaking },
        ])}
      >
        {maskedPasscode.map((_, index) => (
          <MaskedItem key={index} isChecked={!!passcode[index]} />
        ))}
      </div>
      <div className={css.passcodeContainer}>
        {PASSCODE_ITEMS.map((item, index) => (
          <PasscodeItem key={index} value={item} onClick={handleClick} />
        ))}
      </div>
    </div>
  );
};

export default Passcode;
